import { createFormGroupState, FormGroupState } from 'ngrx-forms';

import { CalendarConfiguration, DEFAULT_CALENDAR_CONFIGURATION } from '../../_models';
import { USER_CONFIGURATION_MODULE_KEY } from '../../+state/user-configuration.declarations';

/** keys */
export const CALENDAR_CONGIFURATION_FEATURE_KEY = `${USER_CONFIGURATION_MODULE_KEY}/calendar-configuration`;
export const CALENDAR_CONGIFURATION_FORM_KEY = `${CALENDAR_CONGIFURATION_FEATURE_KEY}/form`;

/** state */
export interface CalendarConfigurationState {
  readonly calendarConfigurationForm: FormGroupState<CalendarConfiguration>;
  readonly originalCalendarConfiguration: CalendarConfiguration;
}

/** defaults */
export const INITIAL_STATE: CalendarConfigurationState = {
  calendarConfigurationForm: createFormGroupState(
    CALENDAR_CONGIFURATION_FORM_KEY,
    DEFAULT_CALENDAR_CONFIGURATION
  ),
  originalCalendarConfiguration: DEFAULT_CALENDAR_CONFIGURATION
};
